
import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '../views/2024/HomeView.vue'
import EAFC24View from '@/views/2024/EAFC24View.vue'
import LeagueOfLegendsView from '@/views/2024/LeagueOfLegendsView.vue'
import PUBGMobileView from '@/views/2024/PUBGMobileView.vue'
import EditionView from '@/views/EditionView.vue'
import LayoutViewer from '@/views/layouts/LayoutViewer.vue'
import GeneralLayoutView from "@/views/2025/GeneralLayoutView.vue";
import MainView from "@/views/2025/MainView.vue";
import TournamentView from "@/views/TournamentView.vue";
import ValorantTournament from "@/views/2025/Tournaments/ValorantTournament.vue";
import EAFCTournament from "@/views/2025/Tournaments/EAFCTournament.vue";
import FreeFireTournament from "@/views/2025/Tournaments/FreeFireTournament.vue";
import StreetFighterTournament from "@/views/2025/Tournaments/StreetFighterTournament.vue";


Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        if (to.hash) {
            return { selector: to.hash };
        }
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/editions',
            component: EditionView,
            meta: {bg: 'white'},
            children:[
                {
                    path: '2024',
                    component: LayoutViewer,
                    children:[
                        {
                            path: '',
                            name: 'home-2024',
                            component: HomeView,
                        },
                        {
                            path:'tournaments',
                            component: TournamentView,
                            children: [
                                {
                                    path: 'eafc24',
                                    name: 'eafc24',
                                    component: EAFC24View
                                },
                                {
                                    path: 'pubgmobile',
                                    name: 'pubgmobile',
                                    component: PUBGMobileView
                                },
                                {
                                    path: 'lol',
                                    name: 'lol',
                                    component: LeagueOfLegendsView
                                },
                            ]
                        },
                    ]
                },
            ]
        },
        // 2025 edition (main)
        {
            path: '/',
            component: GeneralLayoutView,
            children:[
                {
                    path: '',
                    component: MainView,
                    name: 'home',
                },
            ]
        },
        {
            path:'/tournaments',
            component: GeneralLayoutView,
            children:[
                {
                    path: 'valorant',
                    name: 'valorant',
                    component: ValorantTournament
                },
                {
                    path: 'eafc25',
                    name: 'eafc25',
                    component: EAFCTournament
                },
                {
                    path: 'free-fire',
                    name: 'free-fire',
                    component: FreeFireTournament
                },
                {
                    path: 'street-fighter',
                    name: 'street-fighter',
                    component: StreetFighterTournament
                }
            ]
        }
    ]
})

export default router
